import React, { useState } from "react";
import "./footer.css";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaChevronDown
} from "react-icons/fa";

const Footer = () => {
  const [expanded, setExpanded] = useState({
    links: false,
    contact: false,
    social: false,
  });

  const toggleSection = (section) => {
    setExpanded((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Brand Section */}
        <div className="footer-section brand-column">
          <h2 className="footer-logo">Banat</h2>
          <p className="footer-text">
            Building modern digital experiences with creativity,
            simplicity, and innovation.
          </p>
        </div>

        {/* Quick Links Section */}
        <div className={`footer-section accordion-section ${expanded.links ? "is-open" : ""}`}>
          <h3 onClick={() => toggleSection("links")} className="section-title">
            Quick Links
            <FaChevronDown className="accordion-chevron" />
          </h3>
          <div className="accordion-content">
            <a href="/">Home</a>
            <a href="/about">About Us</a>
            <a href="/shop">Products</a>
            <a href="/contact">Contact</a>
          </div>
        </div>

        {/* Contact Section */}
        <div className={`footer-section accordion-section ${expanded.contact ? "is-open" : ""}`}>
          <h3 onClick={() => toggleSection("contact")} className="section-title">
            Contact Us
            <FaChevronDown className="accordion-chevron" />
          </h3>
          <div className="accordion-content">
            <p>📍 Hyderabad, India</p>
            <p>
              ✉️ <a href="mailto:hello@banat.com" className="contact-link">hello@banat.com</a>
            </p>
            <p>
              📞 <a href="tel:+919876543210" className="contact-link">+91 98765 43210</a>
            </p>
          </div>
        </div>

        {/* Social / Follow Us Section */}
        <div className={`footer-section accordion-section ${expanded.social ? "is-open" : ""}`}>
          <h3 onClick={() => toggleSection("social")} className="section-title">
            Follow Us
            <FaChevronDown className="accordion-chevron" />
          </h3>
          <div className="accordion-content">
            <p className="social-subtext">Connect with us on our social platforms for updates.</p>
            <div className="footer-social-icons">
              <a
                href="https://facebook.com/banat"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>

              <a
                href="https://instagram.com/banat"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>

              <a
                href="https://twitter.com/banat"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
              >
                <FaTwitter />
              </a>

              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Banat. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;